
import { Box, Card, Text } from "grommet";

const Grade = (props) => {
    const {eliminateRange, secondChanceRange, commercialPointsRange} = props;

    // console.log ('In Grade props.grade >> ', props.grade);
    const calcBackground = (grade) => {
        if (grade < secondChanceRange.min) return "orange";
        if (grade < commercialPointsRange.min) return "lightyellow";
        return "lightgreen";
    };

    const calcBorder=( grade, range1, range2)=>{
        if(grade >= range1 && grade <= range2)
            return{
                color: "black",
                size: "small",
                style: "solid"
            };
        return  false;
    }

    return (
        <Box direction="column" pad="small" alignSelf="center" >
            <Card 
                background={calcBackground(props.grade)}
                pad="xsmall"  
                style={{
                    marginBottom: "20px", boxShadow: "5px 10px 8px #888888",
                   // background: `radial-gradient(${calcBackground(props.grade)} 60%, ${calcBackground(props.grade)} 60%, #7D4CDB 98%)` 
                }} 
                border={{color: "brand", size: "medium"}}>
                    <Text color="brand" size="large">Total Points  <span style={{whiteSpace: 'pre-line', fontSize: '26px'}}>{props.grade === null ? 0 : props.grade} / {commercialPointsRange.max} </span></Text>
            </Card>
            <Card background="lightgreen" border={calcBorder(props.grade, commercialPointsRange.min, commercialPointsRange.max)} pad="xsmall">
                <Text>Commercial Points &nbsp;
                {commercialPointsRange.min} - {commercialPointsRange.max}</Text>
            </Card>
            <Card background="lightyellow" border={calcBorder(props.grade, secondChanceRange.min, secondChanceRange.max)} pad="xsmall">
                <Text>Second Chance &nbsp;
                {secondChanceRange.min} - {secondChanceRange.max}</Text>
            </Card>
            <Card background="orange" border={calcBorder(props.grade, eliminateRange.min, eliminateRange.max)} pad="xsmall">
                <Text>Eliminate &nbsp;
                {eliminateRange.min} - {eliminateRange.max}</Text>
            </Card>
        </Box>
    );
};

export default Grade;
